import { combineEpics, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import { getSettingsFallbackResp } from 'actions/settings';
import SETTINGS from 'actionTypes/settings';
import { CustomAction } from 'types/Istore';

const settingsFallbackEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SETTINGS.GET_SETTINGS.FAIL),
    map(() => getSettingsFallbackResp())
  );

export default combineEpics(settingsFallbackEpic);
